<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
          <lib-page-header page-title="RECEBIMENTOS ORÇAMENTÁRIOS"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}" page-change="{{pagTitulo}}"
            show-change="true" image-title="assets/img/money7.png">
          </lib-page-header>
        </div>
        <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/recebimentos']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>      
     
      <hr class="mt-0 mb-4" />
      <div class="row mb-3">
        <div class="col-9">
          <label class=" mr-2" style="font-weight: bold; color: #009688 ">FICHA Nº:</label>
          <label *ngIf="entidadeForm.get('guia').value" type="text" readonly id="numero_" style="font-size: 18px; font-weight: bold; color: #009688 ">
            {{ +entidade.ficha?.numero }}
          </label>
        </div>
        <div class="col-3">

        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="data_empenho">Data recebimento</label>
              <input value="{{entidadeForm.get('data_recebimento').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_pagto">
            </div>
            <div *ngIf="entidadeForm.get('data_referencia').value" class="form-group col-md-4">
              <label for="data_vencto">Referência</label>
              <input value="{{entidadeForm.get('data_referencia').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_vencto">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4 pb-0 mb-0">
              <label *ngIf="entidade.especie !== 'ROA'" for="valor_recebido">Valor recebido<span class="text-danger">*</span></label>
              <label *ngIf="entidade.especie === 'ROA'" for="valor_recebido">Valor anulado<span class="text-danger">*</span></label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_recebido" type="text"
                class="form-control-plaintext" id="valor_recebido" readonly placeholder="informe o valor"
                [ngStyle]="entidade.especie === 'ROA' ? {'color': 'red'} : {'color':'#1e88e5'}">
            </div>
          </div>
          <div class="form-row mb-0 pb-0">
            <div class="form-group col-12 pt-0 mt-0 mb-0 pb-0">
              <label for="conta">Conta bancária</label>
              <input *ngIf="entidade.conta"
                value="{{entidade.conta.agencia}} {{entidade.conta.numero_conta}} {{entidade.conta.banco.nome}}"
                readonly type="text" class="form-control-plaintext" id="conta">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="row">
        <div class="col-md-8">
          <div class="form-row">
            <div class="form-group col-12">
              <label for="ficha">Ficha de receita</label>
              <input *ngIf="entidade.ficha" value="{{entidade.ficha.numero}} {{entidade.ficha.receita.nome}}" readonly
                type="text" class="form-control-plaintext font-weight-bold" id="ficha">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="form-row">
        <div class="form-group col-12">
          <label for="historico">Histórico</label>
          <textarea formControlName="historico" readonly class="form-control-plaintext" id="historico"
            rows="5"></textarea>
        </div>
      </div>
    </form>
  </div>
</div>
